var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceExpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5208 5.39062L7.18341 9.11961C7.19083 9.16352 7.18467 9.20865 7.16575 9.24896C7.14683 9.28928 7.11606 9.32285 7.07754 9.3452C7.03902 9.36755 6.9946 9.37761 6.95021 9.37403C6.90582 9.37045 6.86358 9.35341 6.82915 9.32517L5.26337 8.14997C5.18779 8.0935 5.09596 8.06299 5.00161 8.06299C4.90726 8.06299 4.81543 8.0935 4.73985 8.14997L3.17145 9.32474C3.13704 9.35292 3.09485 9.36994 3.05052 9.37352C3.00618 9.37711 2.96181 9.36709 2.92332 9.3448C2.88482 9.32251 2.85404 9.28902 2.83508 9.24878C2.81612 9.20855 2.80987 9.16349 2.81718 9.11961L3.47936 5.39062",
    strokeWidth: 0.874733,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62413 3.2492C7.62413 4.6985 6.44924 5.8734 4.99993 5.8734C3.55063 5.8734 2.37573 4.6985 2.37573 3.2492C2.37573 1.79989 3.55063 0.625 4.99993 0.625C6.44924 0.625 7.62413 1.79989 7.62413 3.2492Z",
    strokeWidth: 0.874733,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceExpIcon);
export default __webpack_public_path__ + "static/media/dice-exp-icon.1f027dcad5a5c8b8d1aa4d572cd6ba2e.svg";
export { ForwardRef as ReactComponent };